import { render, staticRenderFns } from "./WithdrawModal.vue?vue&type=template&id=0879bc5a&scoped=true&"
import script from "./WithdrawModal.vue?vue&type=script&lang=js&"
export * from "./WithdrawModal.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawModal.vue?vue&type=style&index=0&id=0879bc5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0879bc5a",
  null
  
)

export default component.exports